import { JourneysProvider } from "../context/journeys-context";
import { PropTypes } from "base/react-libs";
import JourneyGroupSelector from "../components/journeys-page/top-nav/journey-group-selector";
import JourneysMainContent from "../components/journeys-page/journeys-main-content";
import HomepageMainContent from "../components/home-page/homepage-main-content";

const JourneysHomeController = ({ entryPoint }) => {
  return (
    <JourneysProvider>
      {entryPoint === "home" ? (
        <HomepageMainContent />
      ) : (
        <>
          <JourneyGroupSelector />
          <JourneysMainContent />
        </>
      )}
    </JourneysProvider>
  );
};

JourneysHomeController.propTypes = {
  entryPoint: PropTypes.string,
};

export default JourneysHomeController;
